import type { UserDetails } from './user-profile-details-validator';

// Helpers
export const getUserProfileFullName = (userProfileDetails: UserDetails) => {
  const givenName = userProfileDetails.currentWorkspace.profile.givenName || '';
  const familyName = userProfileDetails.currentWorkspace.profile.familyName || '';
  return `${givenName} ${familyName}`.trim() || undefined;
};

export const isAtLeastAdmin = (userProfileDetails: UserDetails) => {
  return (
    userProfileDetails.currentWorkspace.profile.role === 'ADMIN' ||
    userProfileDetails.currentWorkspace.profile.role === 'OWNER'
  );
};

export const isAtLeastTeamAdmin = (userProfileDetails: UserDetails) => {
  return isAtLeastAdmin(userProfileDetails) && userProfileDetails.currentWorkspace.type === 'TEAM';
};

export const isAtLeastPremiumUser = (userProfileDetails: UserDetails) => {
  return (
    userProfileDetails.currentWorkspace.plan.type === 'PREMIUM' ||
    userProfileDetails.currentWorkspace.plan.type === 'PRO' ||
    userProfileDetails.currentWorkspace.plan.type === 'TEAM'
  );
};

export const getUserHomePageRoute = (userProfileDetails: UserDetails) => {
  if (isAtLeastTeamAdmin(userProfileDetails)) {
    return `/${userProfileDetails.currentWorkspace.id}/home`;
  }

  return `/${userProfileDetails.currentWorkspace.id}/cards/personal`;
};
